import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import {
  ACCESS_TOKEN,
  SKIP_SPLASH,
  AUTH_PERMISSION,
} from '../../../../constants/applicationConstants';
import { useAuth } from '../../Context/AuthContext';
import RoutesItems from '../../../../Routes/RoutesItems';
import useMatchedRoute from '../../../../Utils/Routes/useMatchedRoute';
import {
  checkAdminUser,
  checkFeatureSubscription,
  checkOrganizationUser,
  checkOrganizationAdminUser,
} from '../../../../Utils/Auth/ValidatePermissions';
import { getCookie } from '../../../../Utils/Storage/cookieUtil';

import { Loader, getItem } from 'smart-react';
const Login = React.lazy(() => import('../../Login/Pages/Login'));
/**
 * This component is user as middleware on routes
 * @returns {Login} returns auth UserDetail
 */

const AuthGaurd = () => {
  const route = useMatchedRoute(RoutesItems);

  const { login, checkTokens, featureData } = useAuth();
  const [auth, setAuth] = useState(getCookie(ACCESS_TOKEN) ? true : false);
  /**
   * Check UserDetail is Authenticated or not
   */
  const AuthUser = async () => {
    const skipSplash = getItem(SKIP_SPLASH);
    const isAuthenticated = await checkTokens();
    if (isAuthenticated) {
      setAuth(true);
    } else if (skipSplash) {
      login();
    } else {
      setAuth(false);
    }
  };

  useEffect(() => {
    // Sync process On page reload/Navigate.
    AuthUser();
  }, []);

  /**
   * if Auth gaurd is Active on route and user is authenticated then it will open the requested component otherwise it will redirect to login splash scree
   * and if Auth gaurd is not Active then it will open the requested component with authenticate the user.
   */
  if (route?.isauth) {
    if (auth) {
      if (
        route?.AuthPermission &&
        route?.AuthPermission === AUTH_PERMISSION?.Admin &&
        !checkAdminUser(route)
      ) {
        return <Navigate to='/no-permission' replace={true} />;
      }
      if (
        route?.AuthPermission &&
        route?.AuthPermission === AUTH_PERMISSION?.OrganizationUser &&
        !checkOrganizationUser(route)
      ) {
        return <Navigate to='/no-permission' replace={true} />;
      }
      if (
        route?.AuthPermission &&
        route?.AuthPermission === AUTH_PERMISSION?.OrganizationAdmin &&
        !checkOrganizationAdminUser(route)
      ) {
        return <Navigate to='/no-permission' replace={true} />;
      }
      if (
        route?.AuthPermission &&
        (route?.AuthPermission === 'Autest' ||
          route?.AuthPermission === 'RF') &&
        checkFeatureSubscription(
          featureData,
          AUTH_PERMISSION[route?.AuthPermission],
        )
      ) {
        return <Navigate to='/no-permission' replace={true} />;
      }
      return <Outlet />;
    }
    if (!auth) {
      return (
        <React.Suspense fallback={<Loader />}>
          <Login />
        </React.Suspense>
      );
    }
  }
  return <Outlet />;
};

export default AuthGaurd;
